// Copyright © 2024 650 Industries.

'use client';

import React from 'react';
import { View } from 'react-native';

import { GlassViewProps } from './GlassView.types';

export default function GlassView(props: GlassViewProps) {
  return <View {...props} />;
}
